// UIkit 3.7/3.15-compatible controls stay visible on phones and above editors.
export const photoViewerTemplate = `
<div class="uk-lightbox uk-overflow-hidden guide-photo-lightbox" style="z-index:2200" role="dialog" tabindex="-1" aria-modal="true" aria-label="Photo viewer">
  <style>.guide-photo-lightbox .uk-lightbox-items > li > img { max-width: 100%; max-height: 100%; object-fit: contain; }</style>
  <ul class="uk-lightbox-items" style="position:absolute;inset:56px 0 56px;margin:0"></ul>
  <div class="uk-lightbox-toolbar uk-position-top uk-text-right" style="padding:calc(6px + env(safe-area-inset-top, 0px)) 12px 6px">
    <button class="uk-lightbox-toolbar-icon uk-close-large guide-photo-close" type="button" aria-label="Close photo viewer" style="width:44px;height:44px;border:0;background:transparent;color:white;font-size:32px;line-height:1"><span aria-hidden="true" style="font-size:32px;line-height:1;color:#fff">×</span></button>
  </div>
  <button class="uk-lightbox-button uk-position-center-left" type="button" uk-lightbox-item="previous" aria-label="Previous photo" style="margin-left:12px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(0,0,0,.65);color:white;font-size:32px;line-height:1"><span aria-hidden="true" style="font-size:32px;line-height:1;color:#fff">‹</span></button>
  <button class="uk-lightbox-button uk-position-center-right" type="button" uk-lightbox-item="next" aria-label="Next photo" style="margin-right:12px;width:44px;height:44px;border:0;border-radius:50%;background:rgba(0,0,0,.65);color:white;font-size:32px;line-height:1"><span aria-hidden="true" style="font-size:32px;line-height:1;color:#fff">›</span></button>
  <div class="uk-lightbox-toolbar uk-lightbox-caption uk-position-bottom uk-text-center" aria-live="polite" style="padding:12px 56px calc(12px + env(safe-area-inset-bottom, 0px));color:white"></div>
</div>`;

export function openGuidePhotoViewer(uikit, photos, index, trigger, onHidden) {
  const panel = uikit.lightboxPanel({
    items: photos.map((photo, i) => ({
      source: photo.url,
      type: "image",
      alt: photo.alt || "Property photo",
      // UIkit renders captions as HTML. Only generated numeric text goes here.
      caption: `Photo ${i + 1} of ${photos.length}`,
    })),
    template: photos.length > 1 ? photoViewerTemplate : photoViewerTemplate.replace(/<button[^>]+uk-lightbox-item="(?:previous|next)"[\s\S]*?<\/button>/g, ""),
    animation: "slide",
    draggable: true,
    autoplay: false,
    stack: true,
  });
  panel.$el.addEventListener("shown", () => {
    panel.$el.querySelector(".guide-photo-close")?.focus();
  }, { once: true });
  panel.$el.addEventListener("hidden", () => {
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    onHidden?.();
  }, { once: true });
  panel.show(index);
  return panel;
}
